import { render, staticRenderFns } from "./DeleteGroupLog.vue?vue&type=template&id=dd6babb6&lang=pug&"
import script from "./DeleteGroupLog.vue?vue&type=script&lang=ts&"
export * from "./DeleteGroupLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports